/* eslint-disable prettier/prettier */
class PasswordPrompt {
  constructor(options) {
    this.url = options.url;
    this.callback = options.callback;
    this.evt = options.evt;
    this.passwordField = options.passwordField;
    this.file = options.file;
    this.passwordPromptDiv = options.passwordPromptDiv;
    this._app = options.app;
    this.overlayName = options.overlayName;
    this.container = options.container;
    this.showInvalidPassword = options.showInvalidPassword;
    this.invalidPasswordText = options.invalidPasswordText;
    this.isNewDocument = true;

    const me = this;
    if (!this._app.overlayManager.alreadyRegistered(this.overlayName)) {
      this._app.overlayManager.register(
        this.overlayName,
        this.container,
        this.close.bind(this),
        true
      );
    }

    const clickOK = function (event) {
      if (event.defaultPrevented) {
        return;
      }
      me.isNewDocument = false;
      me.executeCallback();
    };

    const clickCancel = function (event) {
      me.reset();
      if (event.defaultPrevented) {
        return;
      }
      me.close();
    };

    me._app.elements.tw2018elem_passwordPromptOKBtn.removeEventListener(
      "click",
      clickOK
    );
    me._app.elements.tw2018elem_passwordPromptOKBtn.addEventListener(
      "click",
      clickOK
    );
    me._app.elements.tw2018elem_passwordPromptCancelBtn.removeEventListener(
      "click",
      clickCancel
    );
    me._app.elements.tw2018elem_passwordPromptCancelBtn.addEventListener(
      "click",
      clickCancel
    );
  }

  open() {
    if (!this._app.overlayManager._active) {
      Promise.all([this._app.overlayManager.open(this.overlayName)]).then(
        () => {
          this.invalidPasswordText.style.display = this.showInvalidPassword
            ? "inline"
            : "none";
          this.passwordField.value = "";
          this.passwordField.focus();
        }
      );
    }
  }

  close() {
    if (this._app.overlayManager._active) {
      this._app.overlayManager.close(this.overlayName);
    }
  }

  reset() {
    this.passwordField.value = "";
    this.showInvalidPassword = false;
    this.isNewDocument = true;
  }

  executeCallback() {
    this.close();
    if (this.url) {
      this.callback(this.url, this.passwordField.value, this._app);
    } else {
      this.callback(this.file, this.passwordField.value, this._app);
    }
  }
}

export { PasswordPrompt };
